import { PeopleLeaveTypeDto } from "./people-leave-type.dto";
import { PeopleEmployeeDto } from "./employee/people-employee.dto";
import { PeopleQueryBaseDto } from "./people-query-base.dto";
import { Pagination } from "../pagination.dto";

export class PeopleRosterDto {
    id?: number;
    rosterId?: number;
    roster?: any; // RosRosterHeader;
    employeeId?: number;
    employee?: PeopleEmployeeDto;
    isClosed?: number;
    isCover?: number;
    isLocked?: number;
    isActual?: number;
    isTbc?: number;
    rosterStatusId?: number;
    rosterStatus?: any; //RosRosterStatus;
    weekday?: number;
    weekNo?: string;
    startDayNo?: string;
    startDate?: string;
    startRosterTime?: string;
    endRosterTime?: string;
    startClockTime?: string;
    endClockTime?: string;
    breakTime?: string;
    isOnCall?: number;
    totalHours?: string;
    totalCost?: number;
    commentRepublish?: string;
    departmentId?: number;
    merchantId?: number;
    merchantGroupId?: number;
    jobTitleId?: number;
    brandId?: number;
    leaveTypeId?: number;
    rosterLeave?: PeopleLeaveTypeDto;
    notifications?: Array<string>;
    /* local fields */
    changeStatus?: 'create' | 'update' | 'delete';
    searchResults?: number;
    searchJobTitleId?: number;
    searchBrandId?: number;
    employeeList?: any;
    updatedTotalCost?: number;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;
}

export interface PeopleRosterQueryDto extends PeopleQueryBaseDto {
    employee?: string;
    startDate?: string;
    departments?: number[];
    costCentreId?: number;
    merchantId?: number;
    isActual?: boolean;
    actualRules?: string[];
}

export class RosterListDto extends Pagination<PeopleRosterDto> {
    review: any;
  }